<template>
    <div id="app" @contextmenu.prevent >
            <div>
                <el-form :inline="true"  class="demo-form-inline" size="small" @submit.native.prevent @keyup.native.enter="getPolicyList">
                <el-input v-model="searchName"  placeholder="保單號碼"
                          auto-complete="off" style="width:200px;margin: 10px;" >
                </el-input>
                    <el-button type="primary" @click="getPolicyList"><i class="fa fa-search" />查找</el-button>
                </el-form>
                <div style="margin-left: 15px;margin-bottom: 5px;">總單量: {{mcvFeesOrList.length}}</div>
                <el-table :data="mcvFeesOrList" stripe border >
                    <el-table-column type="index" :show-overflow-tooltip="true">

                    </el-table-column>
                    <el-table-column
                                    prop="policyNo"
                                    label="保單號碼"
                                    align="left" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="submitDate"
                            label="投保日期"
                            align="left" :show-overflow-tooltip="true">
                        <template  slot-scope="scope">
                            {{scope.row.submitDate*1000 | date('%Y-%m-%d') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="partnerName"
                            label="合作夥伴"
                            align="left" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="nameEng"
                            label="認證員"
                            align="left" :show-overflow-tooltip="true">
                    </el-table-column>

                </el-table>
            </div>
    </div>

</template>

<script>
    import {queryMcvFeesOrMatchList} from '../api/api';
   /* var PDFJS = require('pdfjs-dist');*/
    //import PDFJS from 'pdfjs-dist/build/pdf.js';
    //PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.js');

    export default {
        name: "attachmentView",
        data() {
            return {
                searchName:"",
                mcvFeesOrList:[],
                count:0
            }
        },
        methods: {
            getPolicyList(){
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if(this.count==1){

                    let params = {trId:this.$route.query.trId,
                        partnerId:this.$route.query.partnerId,month:this.$route.query.month,
                        searchName:this.searchName};
                    return queryMcvFeesOrMatchList(params).then(res=>{
                        if(res.errcode==200){
                            this.mcvFeesOrList = res.data;
                            this.count=0;
                            loading.close();
                            return;

                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("openPolicyList Error");
                    });


                }
                if (this.count < 1) {
                    this.count++;
                    setTimeout(this.getPolicyList, 1000);
                }
            }
        },
            mounted() {
                this.getPolicyList();
            },
            watch: {
            },
        components:{

        },
    }
</script>

<style scoped>

    .bottom_line {
        width: 100%;
        background-color: white;
        position: fixed;
        bottom: 0;
        border: 2px ridge #e68916;
    }
</style>


// WEBPACK FOOTER //
// src/views/PolicyListView.vue